import { render, staticRenderFns } from "./WidgetsConfigHandler.vue?vue&type=template&id=b34cd5cc&scoped=true&"
import script from "./WidgetsConfigHandler.vue?vue&type=script&lang=js&"
export * from "./WidgetsConfigHandler.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsConfigHandler.vue?vue&type=style&index=0&id=b34cd5cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34cd5cc",
  null
  
)

export default component.exports